/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../components/app-nav/app-nav.component.ngfactory';
import * as i3 from '../../../../../src/app/components/app-nav/app-nav.component';
import * as i4 from '../../../../../src/app/containers/app/app.component';
import * as i5 from '../../components/app-header/app-header.component.ngfactory';
import * as i6 from '../../../../../src/app/components/app-header/app-header.component';
import * as i7 from '@angular/common';
import * as i8 from '@angular/router';
import * as i9 from '../../../../../src/store';
import * as i10 from '../../../../../src/auth/shared/services/auth/auth.service';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_AppComponent,
    data:{}});
function View_AppComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'app-nav',([] as any[]),
      (null as any),(null as any),(null as any),i2.View_AppNavComponent_0,i2.RenderType_AppNavComponent)),
      i1.ɵdid(49152,(null as any),0,i3.AppNavComponent,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),[' ']))],(null as any),(null as any));
}
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),16,'div',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),3,'app-header',([] as any[]),(null as any),
          [[(null as any),'logout']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.AppComponent = _v.component;
            if (('logout' === en)) {
              const pd_0:any = ((<any>_co.onLogout()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i5.View_AppHeaderComponent_0,i5.RenderType_AppHeaderComponent)),i1.ɵdid(49152,
      (null as any),0,i6.AppHeaderComponent,([] as any[]),{user:[0,'user']},{logout:'logout'}),
      i1.ɵpid(131072,i7.AsyncPipe,[i1.ChangeDetectorRef]),(_l()(),i1.ɵted((null as any),
          [' '])),(_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),2,(null as any),View_AppComponent_1)),i1.ɵdid(16384,
          (null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),i1.ɵpid(131072,i7.AsyncPipe,[i1.ChangeDetectorRef]),(_l()(),
          i1.ɵted((null as any),['\n\n      '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          4,'div',[['class','wrapper']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(212992,(null as any),0,i8.RouterOutlet,[i8.ChildrenOutletContexts,i1.ViewContainerRef,
          i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n  ']))],(_ck,_v) => {
    var _co:i4.AppComponent = _v.component;
    const currVal_0:any = i1.ɵunv(_v,4,0,i1.ɵnov(_v,5).transform(_co.user$));
    _ck(_v,4,0,currVal_0);
    var tmp_1_0:any = (null as any);
    const currVal_1:any = (((tmp_1_0 = i1.ɵunv(_v,9,0,i1.ɵnov(_v,10).transform(_co.user$))) == null)? (null as any): tmp_1_0.authenticated);
    _ck(_v,9,0,currVal_1);
    _ck(_v,15,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-root',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i1.ɵdid(245760,(null as any),0,i4.AppComponent,[i9.Store,i8.Router,i10.AuthService],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i4.AppComponent> = i1.ɵccf('app-root',
    i4.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2JlbmN1cnJpZS9Eb2N1bWVudHMvVWx0X0FuZy9hbmd1bGFyLXByby1zcmMvYW5ndWxhci1wcm8tYXBwLXNlZWQtbWFzdGVyL3NyYy9hcHAvY29udGFpbmVycy9hcHAvYXBwLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9iZW5jdXJyaWUvRG9jdW1lbnRzL1VsdF9BbmcvYW5ndWxhci1wcm8tc3JjL2FuZ3VsYXItcHJvLWFwcC1zZWVkLW1hc3Rlci9zcmMvYXBwL2NvbnRhaW5lcnMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy9Vc2Vycy9iZW5jdXJyaWUvRG9jdW1lbnRzL1VsdF9BbmcvYW5ndWxhci1wcm8tc3JjL2FuZ3VsYXItcHJvLWFwcC1zZWVkLW1hc3Rlci9zcmMvYXBwL2NvbnRhaW5lcnMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9Vc2Vycy9iZW5jdXJyaWUvRG9jdW1lbnRzL1VsdF9BbmcvYW5ndWxhci1wcm8tc3JjL2FuZ3VsYXItcHJvLWFwcC1zZWVkLW1hc3Rlci9zcmMvYXBwL2NvbnRhaW5lcnMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPGRpdj5cbiAgICAgIDxhcHAtaGVhZGVyIFt1c2VyXT1cInVzZXIkIHwgYXN5bmNcIiAobG9nb3V0KT1cIm9uTG9nb3V0KClcIj4gPC9hcHAtaGVhZGVyPlxuICAgICAgPGFwcC1uYXYgKm5nSWY9XCIodXNlciQgfCBhc3luYyk/LmF1dGhlbnRpY2F0ZWRcIj4gPC9hcHAtbmF2PlxuXG4gICAgICA8ZGl2IGNsYXNzPVwid3JhcHBlclwiPlxuICAgICAgICA8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+XG4gICAgICA8L2Rpdj5cbiAgICA8L2Rpdj5cbiAgIiwiPGFwcC1yb290PjwvYXBwLXJvb3Q+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDR007TUFBQTthQUFBO1VBQUEsZUFBZ0Q7OztvQkFIdEQsMkNBQ0k7TUFBQTtNQUFBLDhCQUFLLDZDQUNIO2FBQUE7VUFBQTtZQUFBO1lBQUE7WUFBbUM7Y0FBQTtjQUFBO1lBQUE7WUFBbkM7VUFBQSx5RUFBQTtNQUFBO2FBQVksNkNBQTZDO1VBQUEsUUFBYyw2Q0FDdkU7VUFBQSx5RUFBQTtVQUFBO1VBQUEsc0JBQVMsNkNBQWtEO2lCQUFBLGdDQUUzRDtVQUFBO1VBQUEsOEJBQXFCO01BQ25CO1VBQUE7YUFBQTtzQ0FBQTtVQUFBLGVBQStCLDZDQUMzQjtVQUFBLGFBQ0Y7O0lBTlE7SUFBWixXQUFZLFNBQVo7SUFDUztJQUFBO0lBQVQsV0FBUyxTQUFUO0lBR0U7Ozs7b0JDTlI7TUFBQTthQUFBO1VBQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./ngfactory/src/app/containers/app/app.component.ngfactory.ts